export const MAIN_THEME_COLOR = '#00A884';
export const WHITE = '#FFFFFF';
export const BLACK = '#111B21';
export const GREY = '#667781';
